import { render, staticRenderFns } from "./PhoneClientForSuicidalCheck.vue?vue&type=template&id=3d5a2185&"
import script from "./PhoneClientForSuicidalCheck.vue?vue&type=script&lang=ts&"
export * from "./PhoneClientForSuicidalCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports